import { Box, SvgIcon, Typography } from "@mui/material";
import { mdiPackageVariantClosed } from "@mdi/js";
import dateformat from "dateformat";
import { IconButton } from "$components/Buttons/IconButton";
import { PreparationOrderStatus } from "$types";
import { DEFAULT_DATE_FORMAT } from "$utils/utils";
import { useStyles } from "./Preparation.styles";
import StatusHistoryButton from "./StatusHistoryButton";

export const RenderStatus = ({ op, togglePopin, setSelectOp }: any) => {
  const classes = useStyles();
  const { isDisable, status, statusHistory } = op;

  const renderDateOP = (status: any, statusHistory: any) => {
    const isEditable =
      status > PreparationOrderStatus.CREATED &&
      status <= PreparationOrderStatus.PREPARED;
    const historyStatus = statusHistory?.filter(
      (history: any) => history.status === status
    );
    const dateValue =
      historyStatus?.length > 0
        ? historyStatus[historyStatus.length - 1].statusDate?.substring(0, 10)
        : "";
    return {
      isEditable,
      historyStatus,
      dateValue,
    };
  };

  return (
    <>
      <Box>
        <StatusHistoryButton disabled={isDisable} op={op} />
        <Typography
          variant="caption"
          component="p"
          className={classes.formatDate}
        >
          {renderDateOP(status, statusHistory).dateValue
            ? dateformat(
                new Date(renderDateOP(status, statusHistory).dateValue),
                DEFAULT_DATE_FORMAT
              )
            : ""}
        </Typography>
      </Box>
      {status !== PreparationOrderStatus.CREATED &&
        status !== PreparationOrderStatus.CANCELLED && (
          <IconButton
            icon={
              <SvgIcon htmlColor="black">
                <path d={mdiPackageVariantClosed} />
              </SvgIcon>
            }
            onClick={() => {
              setSelectOp(op);
              togglePopin();
            }}
          />
        )}
    </>
  );
};
